export default __webpack_public_path__ + "static/media/desert.86e54032.ogg";